module.exports = __webpack_public_path__ + "media/coins.5eba0467.mp3";